import { EnumValues } from 'enum-values'
import { FeatureFlag } from './types'
import { Package } from './types/Package'

const spareAiPlatformFeatureFlags = [
  FeatureFlag.LaunchAIVoice,
  FeatureFlag.SpareAiChatL2,
  FeatureFlag.AiChat,
  FeatureFlag.AiVoiceAddPaymentMethod,
  FeatureFlag.AiVoicePhoneNumberWithIdAndPinFallback,
]

const spareEligibilityPlatformFeatureFlags = [
  FeatureFlag.EngageAIScan,
  FeatureFlag.EngageAIVoice,
  FeatureFlag.CaseSummary,
  FeatureFlag.EngageRiderHub,
  FeatureFlag.SensitiveDataField,
  FeatureFlag.HideEmptyAppointmentLocation,
  FeatureFlag.AllowIncompleteForms,
  FeatureFlag.EdiEligibility,
]

const spareResolvePlatformFeatureFlags = [FeatureFlag.OperationsCaseCreation]

const spareEnterpriseFeatureFlags = [
  FeatureFlag.DriverDispatchCommunication,
  FeatureFlag.DutyPulloutVisibility,
  FeatureFlag.DriverInAppCalling,
  FeatureFlag.VehicleInspections,
  FeatureFlag.ViewDriverKpis,
  FeatureFlag.OptimizationInsights,
  FeatureFlag.DemandForecasting,
  FeatureFlag.TripGroup,
  FeatureFlag.FleetArea,
  FeatureFlag.CompleteActivityLog,
  FeatureFlag.OrganizationPrivacyConfigurations,
  FeatureFlag.DataReconciliation,
  FeatureFlag.FixedRouteTravelDuration,
  FeatureFlag.FixedRouteAlternativesInLaunch,
  FeatureFlag.MultipleWorkflows,
  FeatureFlag.ConditionalEligibility,
]

const spareOneFeatureFlags = [FeatureFlag.Multimodal, FeatureFlag.Tickets, FeatureFlag.RiderGtfsScheduleViewer]

const spareIvrFeatureFlags = [
  FeatureFlag.IvrCallRecording,
  FeatureFlag.PhoneIvrEta,
  FeatureFlag.PhoneIvrBookRide,
  FeatureFlag.PhoneIvrCancelRide,
  FeatureFlag.RiderPhonePin,
]

const spareOpenFleetsFeatureFlags = [
  FeatureFlag.OpenFleet,
  FeatureFlag.OpenFleetRematching,
  FeatureFlag.PublishDispatchingEvents,
  FeatureFlag.ShowDispatchingEvents,
]

const spareStandardAdminsServicePlannersFeatureFlags = [
  FeatureFlag.LatenessThresholdOneMinute,
  FeatureFlag.AutoCompleteOnlyWhenAtEndLocation,
  FeatureFlag.AllowMatchingConfiguration,
  FeatureFlag.ShowTargetedOptimization,
  FeatureFlag.VehicleClass,
  FeatureFlag.FareRules,
  FeatureFlag.ZoneStopLibrary,
  FeatureFlag.TransactionGrouping,
  FeatureFlag.DisablePleoLiveMessage,
  FeatureFlag.DisablePleoManualInterventions,
  FeatureFlag.AllowBookingWithoutPaymentMethod,
  FeatureFlag.StripeCustomerDetails,
  FeatureFlag.MergeZonesOnServicesPage,
  FeatureFlag.ReportTemplate,
  FeatureFlag.OrganizationSwitcherPopover,
  FeatureFlag.CustomCancellationReasons,
  FeatureFlag.TotalRevenueHoursV2,
  FeatureFlag.InAppTesting,
  FeatureFlag.DataRetention,
]

const spareStandardDispatchBookingAgentsFeatureFlags = [
  FeatureFlag.LiveMessagesNotificationSound,
  FeatureFlag.MergeZonesOnLiveMap,
  FeatureFlag.MergeZonesOnDutyTimeTravel,
  FeatureFlag.LiveGlobalOptimization,
  FeatureFlag.EngineV2GlobalOptimization,
  FeatureFlag.LockToDuty,
  FeatureFlag.ConstraintOverrides,
  FeatureFlag.ForceMatch,
  FeatureFlag.ManualInterventions,
  FeatureFlag.AddRecurringTripFromRequestV2,
  FeatureFlag.MoreFrequentOptimization,
  FeatureFlag.LiveMapAlerts,
  FeatureFlag.WatchlistAlertActions,
  FeatureFlag.BreaksWithLocations,
  FeatureFlag.ImprovedNegotiationUi,
  FeatureFlag.RecurringTrips,
  FeatureFlag.LiveRequest,
  FeatureFlag.BookingCopilot,
  FeatureFlag.RequestActivityFeed,
  FeatureFlag.RiderViewPeek,
  FeatureFlag.LocationNotes,
]

const spareStandardDriverExperienceFeatureFlags = [
  FeatureFlag.DisableDriverAppFlagDown,
  FeatureFlag.DisableEditingAddingVehicle,
  FeatureFlag.ShowAllSlotsToDriver,
  FeatureFlag.DriverTripHistory,
  FeatureFlag.TipPolicies,
  FeatureFlag.UnscheduledDriving,
  FeatureFlag.AcceptRejectFleet,
  FeatureFlag.DriverRiderReviews,
  FeatureFlag.DriverBreaks,
  FeatureFlag.DriverShowRiderFullName,
  FeatureFlag.UseDriverAppBearing,
  FeatureFlag.DisableNavigationIos,
  FeatureFlag.DisableNavigationAndroid,
  FeatureFlag.DisplayDriveUntilMessaging,
  FeatureFlag.DriverIdleMap,
  FeatureFlag.IncidentReporting,
  FeatureFlag.DriverAppRouteDistanceOnly,
  FeatureFlag.DisableDriverControlSoundNotifications,
]

const spareStandardRiderExperienceFeatureFlags = [
  FeatureFlag.SMSRiderNotifications,
  FeatureFlag.SmsEta,
  FeatureFlag.SmsCancelRide,
  FeatureFlag.BulkMessages,
  FeatureFlag.LanguageAndChannelPreferences,
  FeatureFlag.EtaChangedNotifications,
  FeatureFlag.VoiceNotifications,
  FeatureFlag.RiderZoneRestrictionByGroups,
  FeatureFlag.RiderRepresentatives,
  FeatureFlag.Announcements,
  FeatureFlag.CallForVerificationCode,
  FeatureFlag.RecurringTripsInRider,
  FeatureFlag.DisplayZonesOnRider,
  FeatureFlag.Promos,
  FeatureFlag.FarePasses,
  FeatureFlag.Wallet,
  FeatureFlag.ValidatePickupAndDropoffLocationsRider,
  FeatureFlag.ReduceRiderEstimatePollingRate,
]

const doNotEnableFeatureFlags = [
  FeatureFlag.CustomRoles,
  FeatureFlag.CapMetroCustomRoles,
  FeatureFlag.CapMetroGroupExpiryNotifications,
  FeatureFlag.RequestInsights,
  FeatureFlag.LyftPassLink,
  FeatureFlag.ManuallyTriggeredOptimization,
  FeatureFlag.LiveTraffic,
  FeatureFlag.RestrictedArea,
  FeatureFlag.OsrmTableElementCaching,
  FeatureFlag.GoogleRoutingTesting,
  FeatureFlag.UseNavigationService,
  FeatureFlag.Routes,
  FeatureFlag.MultimodalTransitHubs,
  FeatureFlag.TelecomsV2,
  FeatureFlag.PhoneNumberWebhookMigration,
  FeatureFlag.DutySchedulePlusPlusDetails,
  FeatureFlag.MergeZonesOnRider,
  FeatureFlag.FixedRouteAntiCannibalization,
  FeatureFlag.DutyScheduleRequestsEndpoint,
  FeatureFlag.AsapDriverBreaks,
  FeatureFlag.DutyInterruptionReasons,
  FeatureFlag.DutyDelays,
  FeatureFlag.DARTDetourFlexibilityExperiment,
  FeatureFlag.RequestTimeline,
  FeatureFlag.GoogleMapsOnDriverApp,
  FeatureFlag.QuickReplies,
  FeatureFlag.GoogleMapsPerTripBilling,
  FeatureFlag.DriverBehavioursInDriverApp,
  FeatureFlag.DutyActivityFeed,
  FeatureFlag.FixedRouteEquivalentDetour,
  FeatureFlag.LiveGlobalOptimizationExtendedRuntime,
  FeatureFlag.RequireBreaksWithLocationsToBeStartedManually,
  FeatureFlag.DisableDriverOfflineScreen,
  FeatureFlag.MergeZonesServerSide,
  FeatureFlag.MetabaseReports,
  FeatureFlag.AnalyticsV2,
  FeatureFlag.DirectorySync,
  FeatureFlag.AnalyticsAboveLaunchAndEngage,
  FeatureFlag.MbtaTestOrgSftp,
  FeatureFlag.MbtaProdOrgSftp,
  FeatureFlag.TestNewLoadBalancer,
  FeatureFlag.PermissionBasedSidebarProductVisibility,
  FeatureFlag.AuditLogs,
  FeatureFlag.RenameAccessibilityFeatures,
  FeatureFlag.ShallowSearchAllWindows,
  FeatureFlag.ExcludeWalkingTimeInDesiredTs,
  FeatureFlag.EnableSlotCompleteInVehicleStatus,
  FeatureFlag.RenameAccessibilityFeaturesMBTA,
  FeatureFlag.ExperimentalMapStyles,
  FeatureFlag.AiInWorkflows,
  FeatureFlag.RbacProviderUi,
  FeatureFlag.DutyCancellationReasons,
  FeatureFlag.AddressV2,
  FeatureFlag.VisitorConditions,
  FeatureFlag.EnableGBFSTripPlanning,
  FeatureFlag.DARTCrossFleetOptimization,
  FeatureFlag.ReadOnlyExternalRiderIds,
  FeatureFlag.UseDynamicCubes,
  FeatureFlag.UpcomingStopsVisibility,
  FeatureFlag.AiVoiceFixedRouteEta,
  FeatureFlag.LaMetroHardcodedRiderDescriptions,
  FeatureFlag.EnableRiderAppMixpanelAnalytics,
  FeatureFlag.DisableRiderAppPhotoEditing,
  FeatureFlag.DisableRiderOnboarding,
  FeatureFlag.DisableUpdatingDefaultProfileFields,
  FeatureFlag.HideStopDescriptionsOnRiderTimeline,
  FeatureFlag.DisableLocationNotesInRiderApp,
  FeatureFlag.HideAlternativeTripTimes,
  FeatureFlag.PromptToCancelReturnTrip,
  FeatureFlag.LogDenials,
]

const productionFeatureFlags = new Set([
  ...doNotEnableFeatureFlags,
  ...spareAiPlatformFeatureFlags,
  ...spareEligibilityPlatformFeatureFlags,
  ...spareResolvePlatformFeatureFlags,
  ...spareEnterpriseFeatureFlags,
  ...spareIvrFeatureFlags,
  ...spareOneFeatureFlags,
  ...spareOpenFleetsFeatureFlags,
  ...spareStandardAdminsServicePlannersFeatureFlags,
  ...spareStandardDispatchBookingAgentsFeatureFlags,
  ...spareStandardDriverExperienceFeatureFlags,
  ...spareStandardRiderExperienceFeatureFlags,
])

export const toBeRemovedSoonFeatureFlags = EnumValues.getValues<FeatureFlag>(FeatureFlag).filter(
  (flag) => !productionFeatureFlags.has(flag),
)

export const PackageFeatureFlagMap: Record<Package, FeatureFlag[]> = {
  [Package.SpareAiPlatform]: spareAiPlatformFeatureFlags,
  [Package.SpareEligibilityPlatform]: spareEligibilityPlatformFeatureFlags,
  [Package.SpareResolvePlatform]: spareResolvePlatformFeatureFlags,
  [Package.SpareEnterprise]: spareEnterpriseFeatureFlags,
  [Package.SpareIvr]: spareIvrFeatureFlags,
  [Package.SpareOne]: spareOneFeatureFlags,
  [Package.SpareOpenFleets]: spareOpenFleetsFeatureFlags,
  [Package.SpareStandardAdminsServicePlanners]: spareStandardAdminsServicePlannersFeatureFlags,
  [Package.SpareStandardDispatchBookingAgents]: spareStandardDispatchBookingAgentsFeatureFlags,
  [Package.SpareStandardDriverExperience]: spareStandardDriverExperienceFeatureFlags,
  [Package.SpareStandardRiderExperience]: spareStandardRiderExperienceFeatureFlags,
  [Package.ToBeRemovedSoon]: toBeRemovedSoonFeatureFlags,
  [Package.DoNotEnable]: doNotEnableFeatureFlags,
}

export const featureEntitlementExclusions = new Set([...toBeRemovedSoonFeatureFlags, ...doNotEnableFeatureFlags])

export function isRestrictedFeatureFlag(featureFlag: FeatureFlag): boolean {
  return doNotEnableFeatureFlags.includes(featureFlag)
}
